import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import firebase from '../db/firebase/firebase';
import { motion } from 'framer-motion';

const RequestsMoney = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const q = query(collection(firebase.db, 'requestsMoney'), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, snapshot => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setRequests(data);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const getStateColor = (state) => {
    switch (state) {
      case 'approved':
      case 'answer':
        return 'text-green-600 font-bold';
      case 'pending':
        return 'text-yellow-600 font-bold';
      case 'rejected':
        return 'text-red-600 font-bold';
      default:
        return 'text-gray-700';
    }
  };

  if (loading) {
    return (
      <div className="flex-1 h-full flex items-center justify-center bg-white z-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-gray-800"></div>
      </div>
    );
  }

  return (
    <div className="flex-1 p-6 h-screen overflow-y-auto bg-gray-300">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Money Requests</h2>
      </div>

      <div className="flex items-center w-full bg-gray-100 p-4 rounded mb-4 text-sm font-medium text-gray-700">
        <span className="flex-1">Name</span>
        <span className="flex-1">Email</span>
        <span className="flex-1">Amount</span>
        <span className="flex-1">Created At</span>
        <span className="w-24 text-center">State</span>
        <span className="w-32 text-center">Actions</span>
      </div>

      {requests.length === 0 ? (
        <p className="text-center text-gray-500 mt-10">No money requests to display.</p>
      ) : (
        <div className="space-y-4">
          {requests.map(req => (
            <motion.div
              key={req.id}
              layout
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="w-full p-4 rounded shadow bg-white flex items-center text-sm"
            >
              <p className="flex-1 font-semibold text-lg">{req.name}</p>
              <p className="flex-1 text-gray-600">{req.user?.email || '-'}</p>
              <p className="flex-1 text-xl font-extrabold text-gray-800">£{req.amount}</p>
              <p className="flex-1 text-gray-500">
                {req.createdAt
                  ? new Date(req.createdAt).toLocaleString()
                  : 'N/A'}
              </p>
              <p className={`w-24 text-center capitalize ${getStateColor(req.state)}`}>
                {req.state}
              </p>
              <div className="w-32 flex justify-center">
                <button
                  onClick={() => navigate(`/requests-money/${req.id}`)}
                  className="text-[#5298A8] font-bold hover:underline"
                >
                  View
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RequestsMoney;